const drawerWidth = 325;

export default theme => ({
  returnToDashboardSnackbar: {
    minWidth: 850,
    backgroundColor: theme.palette.error.dark,
  },
  root: {
    width: '100%',
    position: 'fixed',
    height: '100vh',
    // display: "grid",
    // gridTemplateRows: "64px auto 68px"
    display: 'flex',
    flexDirection: 'column',
  },
  reviewHeader: {
    marginLeft: drawerWidth,
  },
  drawer: {
    width: drawerWidth,
  },
  drawerOpen: {
    marginLeft: drawerWidth,
  },
  contentWrapper: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxHeight: 'calc(100vh - 95px)',
    maxWidth: '100%',
  },
  loadingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100vh',
  },
  progressWrapper: {
    margin: '0 auto',
    textAlign: 'center',
  },
  progressTitle: {
    marginBottom: 24,
  },
  sideNavWrapper: {
    zIndex: 0,
    borderRadius: 0,
    // background: "#315382",
    backgroundColor: 'var(--jmi-blue)',
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexGrow: 1,
    // width: drawerWidth
  },
  sideNavList: {
    width: '100%',
    maxWidth: 360,
    // backgroundColor: "#315382",
    marginTop: 0,
    '& svg': {
      fill: '#7790b3',
    },
    '& ul': {
      marginTop: 0,
    },
  },
  completeButton: {
    color: '#fff',
    backgroundColor: '#71BF47',
    '&:hover': {
      background: '#4f8a30',
    },
  },
  completeButtonFocused: {
    backgroundColor: '#4f8a30',
  },
  rejectButton: {
    backgroundColor: '#f44336',
    color: '#fff',
    '&:hover': {
      background: '#d2190b',
    },
    rejectButtonFocused: {
      backgroundColor: '#d2190b',
    },
  },
  orderInfo: {
    // backgroundColor: "#2a466f"
    backgroundColor: '#315382',
  },
  orderInfoTitle: {
    color: '#fff',
    lineHeight: 'normal',
    display: 'inline-block',
    textTransform: 'capitalize',
    fontWeight: '300',
    margin: '0',
  },
  pdfPreview: {
    marginTop: '2rem',
    padding: '1rem',
    paddingBottom: '105px',
    maxWidth: '1000px',
    margin: '0 auto',
  },
  dialogTitle: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  dialogActions: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // backgroundColor: "#fff"
    // backgroundColor: '#315382'
  },
  tooltip: {
    fontSize: '1rem',
  },
  pdfDialog: {
    '& div:nth-child(2)': {
      display: 'flex',
    },
  },

  toolbarAttribute: {
    color: '#5e80ae',
    lineHeight: 'normal',
    display: 'inline-block',
    textTransform: 'capitalize',
    '& span': {
      color: '#fff',
    },
    textAlign: 'left',
    margin: '0.25rem 0',
  },

  // header stuff
  returnToGridLink: {
    color: '#6FBE48',
    fontSize: 14,
    cursor: 'pointer',
    marginLeft: -5,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
  orderNumberLabel: {
    fontSize: 18,
    color: 'var(--jmi-blue)',
    fontWeight: 'bold',
  },
  orderTicketNumber: {
    lineHeight: 'normal',
    margin: '0.25rem auto',
  },
  clientLogo: {
    height: '75%',
    marginLeft: 20,
    maxWidth: 200,
    maxHeight: 50,
  },

  instructionsList: {
    paddingLeft: 20,

    '& > li:not(:first-child)': {
      marginTop: 10,
    },
  },
});
